module.exports = __webpack_public_path__ + "img/mt17.5d238756.jpg";